export function targetadsPush(eventType: string, params: object): void {
  try {
    window.targetAdsDataLayer.push({
      eventType,
      params,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('targetAdsDataLayer push failed', error);
  }
}
